/* Ninja Toolkit (Justin 2026-11-03) — the stage tool row's look, shared by DTF By Size v5, UV By Size and the DTF + UV gang upload pages.
   - icons: ic(name) = the tinted tile icon; header(id) = the "Ninja Toolkit" show / hide header.
   - show / hide state, the phone row's fade, and the multi-upload AI Edit Tools menu icons are wired here once.
   - By Size v5 (bysize-v5-tools.js) builds its bar with these. Any other page that loads this file (UV By Size uv-by-size-v4,
     gang uploads gang-upload-v3 / uv-gang-upload-v3) keeps the bundle's own bar markup; skin() re-dresses it after each render: the header
     goes in, each tool's icon becomes its tile, the tools take the toolkit order. Hooks, handlers and the cart
     payload are untouched — this file never turns on the v5 engine (window.__bsv5Tools).
   CSS: nt-stage-tools.css (.bsv5-tools / html.nt-tk). Loaded before bysize-v5-tools.js in layout/theme.liquid. */
(function () {
  'use strict';
  if (window.NTToolkit) return;
  document.documentElement.classList.add('nt-tk');

  /* Ninja Toolkit (Justin 11-03 mock 1b): every tool is an icon tile (tinted rounded square, own colour) with the label under it.
     Icons are drawn here so the row matches the mock; the hooks/classes on each button are unchanged. */
  function svg(d, sw) { return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="' + (sw || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
  var TK = {
    aiEdit: svg('<path d="M21.6 3.6l-1.2-1.2a1.2 1.2 0 0 0-1.7 0L2.4 18.6a1.2 1.2 0 0 0 0 1.7l1.2 1.2a1.2 1.2 0 0 0 1.7 0L21.6 5.4a1.2 1.2 0 0 0 0-1.8"/><path d="M14 7l3 3"/><path d="M5 6v4M19 14v4M10 2v2M7 8H3M21 16h-4M11 3H9"/>', 1.9),
    recolor: svg('<path d="M12 3a9 9 0 0 0 0 18c1 0 1.6-.8 1.6-1.6 0-.5-.2-.8-.5-1.1-.3-.3-.4-.7-.4-1.1 0-.9.7-1.6 1.6-1.6h1.9A4.8 4.8 0 0 0 21 10.8C21 6.5 17 3 12 3z"/><circle cx="7.5" cy="11.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="10" cy="7.6" r="1.1" fill="currentColor" stroke="none"/><circle cx="14.6" cy="7.6" r="1.1" fill="currentColor" stroke="none"/><circle cx="17.3" cy="11" r="1.1" fill="currentColor" stroke="none"/>'),
    addText: svg('<path d="M5 6V4.5h14V6"/><path d="M12 4.5v15"/><path d="M9 19.5h6"/>', 2.2),
    upscale: svg('<path d="M15 3h6v6"/><path d="M21 3l-7 7"/><path d="M9 21H3v-6"/><path d="M3 21l7-7"/>', 2.2),
    crop: svg('<path d="M6 2v14a2 2 0 0 0 2 2h14"/><path d="M18 22V8a2 2 0 0 0-2-2H2"/>', 2.2),
    eraser: svg('<path d="M7 20.5l-4-4a2 2 0 0 1 0-2.8l9.2-9.2a2 2 0 0 1 2.8 0l5 5a2 2 0 0 1 0 2.8L12.5 20.5"/><path d="M21 20.5H7"/><path d="M6.5 10.5l7 7"/>'),
    filters: svg('<circle cx="12" cy="8.5" r="4.8"/><circle cx="8.5" cy="14.5" r="4.8"/><circle cx="15.5" cy="14.5" r="4.8"/>', 1.9)
  };
  function ic(k) { return '<span class="bsv4-aitools__icon bsv5-tk__ic bsv5-tk__ic--' + k + '" aria-hidden="true">' + TK[k] + '</span>'; }
  /* show / hide (Owen 11-03): the header opens and closes the tool row; Add a Note stays. The choice is kept per viewer
     (one key for both pages) */
  var KEY = 'bsv5-tools-open', open = true;
  try { open = localStorage.getItem(KEY) !== '0'; } catch (e) {}
  var LOGO = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.5c.6 4.6 2.9 6.9 9.5 9.5-6.6 2.6-8.9 4.9-9.5 9.5-.6-4.6-2.9-6.9-9.5-9.5 6.6-2.6 8.9-4.9 9.5-9.5z"/><circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/></svg>';
  var CHEV = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10l4-4 4 4"/></svg>';
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-bsv5-tools-toggle]');
    if (!b) return;
    open = !open;
    try { localStorage.setItem(KEY, open ? '1' : '0'); } catch (e2) {}
    [].forEach.call(document.querySelectorAll('[data-bsv5-tools-toggle]'), function (t) {
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      var box = t.closest('.bsv4-aitools--stage'); if (box) box.classList.toggle('bsv5-tools--shut', !open);
    });
  });

  /* phones: the tile row scrolls sideways with a fade at the right; once scrolled to the end the fade goes.
     Re-measured on every scroll + resize (a layout pass can scroll the row before it overflows) */
  function fadeSync(b) {
    var box = b && b.closest && b.closest('.bsv5-tools'); if (!box) return;
    var end = b.scrollLeft > 0 && b.scrollLeft + b.clientWidth >= b.scrollWidth - 4;
    if (box.classList.contains('bsv5-tk--end') !== end) box.classList.toggle('bsv5-tk--end', end);
  }
  document.addEventListener('scroll', function (e) {
    var b = e.target;
    if (b && b.classList && b.classList.contains('bsv4-aitools__bar')) fadeSync(b);
  }, true);
  window.addEventListener('resize', function () { [].forEach.call(document.querySelectorAll('.bsv5-tools > .bsv4-aitools__bar'), fadeSync); });

  /* multi upload (Justin 11-03 "carry the icons over"): each design card's AI Edit Tools menu gets the Ninja Toolkit tiles.
     Only an item without one is touched (never rewrite a clickable node on every mutation — Safari drops the click) */
  var MENU_KEYS = [['[data-bsv4-edit-open]', 'aiEdit'], ['.nt-recolor-btn', 'recolor'], ['[data-bsv4-addtext]', 'addText'], ['[data-bsv4-upscale]', 'upscale'],
    ['[data-ntst-crop], [data-ntst-mcrop]', 'crop'], ['[data-bsv4-erase]', 'eraser'], ['[data-bsv4-fx]', 'filters']];
  function menuIcons() {
    [].forEach.call(document.querySelectorAll('.bsv4-aitools__menu > .bsv4-aitools__item'), function (it) {
      var k = null;
      MENU_KEYS.some(function (m) { if (it.matches(m[0])) { k = m[1]; return true; } return false; });
      if (!k || it.querySelector(':scope > .bsv5-tk__ic--' + k)) return;   /* (the menu's Crop is a clone of Swap Colors: wrong tile = swap) */
      var old = it.querySelector(':scope > .bsv5-tk__ic, :scope > .bsv4-aitools__icon, :scope > svg');
      var tmp = document.createElement('span'); tmp.innerHTML = ic(k);
      if (old) it.replaceChild(tmp.firstChild, old); else it.insertBefore(tmp.firstChild, it.firstChild);
    });
  }
  function header(id) {
    return '<button type="button" class="bsv5-th" data-bsv5-tools-toggle aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="' + id + '">' +
      '<span class="bsv5-th__logo" aria-hidden="true">' + LOGO + '</span><span class="bsv5-th__txt"><span class="bsv5-th__name">Ninja Toolkit</span>' +
      '<span class="bsv5-th__sum">Fine-tune your artwork before we print it.</span></span>' +
      '<span class="bsv5-th__chev">' + CHEV + '</span></button>';
  }

  /* pages without the v5 tool list (UV By Size): dress the bundle's own stage bar. Runs on every DOM change but only
     touches what is missing or out of place, so a settled bar is never rewritten. Remove BG / BG Color / Notes stay put. */
  var ORDER = ['aiEdit', 'recolor', 'addText', 'upscale', 'crop', 'eraser', 'filters'];
  function kind(b) {
    for (var i = 0; i < MENU_KEYS.length; i++) if (b.matches(MENU_KEYS[i][0])) return MENU_KEYS[i][1];
    return null;
  }
  var seq = 0;
  function skin() {
    if (window.__bsv5Tools) return;
    [].forEach.call(document.querySelectorAll('.bsv4-preview--stagetools .bsv4-aitools--stage'), function (card) {
      if (card.closest('.ntre__mx')) return;   /* the Request Edits modal's copy of the card: its tiles are clones, no header there */
      var bar = card.querySelector(':scope > .bsv4-aitools__bar'); if (!bar) return;
      if (!card.classList.contains('bsv5-tools')) { card.classList.add('bsv5-tools'); if (!open) card.classList.add('bsv5-tools--shut'); }
      if (!bar.id) bar.id = 'nt-tk-' + (++seq);
      if (!card.querySelector(':scope > .bsv5-th')) {
        var t = document.createElement('div'); t.innerHTML = header(bar.id);
        card.insertBefore(t.firstChild, bar);
      }
      var tools = [];
      [].forEach.call(bar.children, function (b) {
        var k = b.classList.contains('bsv4-aitools__tool') && kind(b); if (!k) return;
        tools.push([k, b]);
        if (!b.querySelector(':scope > .bsv5-tk__ic--' + k)) {
          var old = b.querySelector(':scope > .bsv5-tk__ic, :scope > .bsv4-aitools__icon, :scope > svg');
          var tmp = document.createElement('span'); tmp.innerHTML = ic(k);
          if (old) b.replaceChild(tmp.firstChild, old); else b.insertBefore(tmp.firstChild, b.firstChild);
        }
      });
      var want = tools.slice().sort(function (a, b) { return ORDER.indexOf(a[0]) - ORDER.indexOf(b[0]); });
      var inOrder = want.every(function (w, i) { return w[1] === tools[i][1]; });
      if (!inOrder) {
        var anchor = tools[0][1];   /* the first tool's slot: Remove BG (phones) stays in front of the row */
        var ref = anchor.previousSibling;
        want.forEach(function (w) { bar.insertBefore(w[1], ref ? ref.nextSibling : bar.firstChild); ref = w[1]; });
      }
    });
  }

  var mq = 0;
  new MutationObserver(function () { if (!mq) mq = requestAnimationFrame(function () { mq = 0; skin(); menuIcons(); }); })
    .observe(document.documentElement, { childList: true, subtree: true });

  window.NTToolkit = { ic: ic, header: header, isOpen: function () { return open; }, order: ORDER };
})();
